import React, { useEffect, useState, useRef } from 'react';
import { usePartnerContext } from '../../components/Context/PartnerContext';
import { useSnackbar } from '.././SnackBar';
import ConfirmDialog from '../../views/ConfirmDialog';
import { Tabs, Tab, Box, Typography, Button, TextField, InputAdornment, IconButton, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useNavigate } from 'react-router-dom';
import { useProgressBar } from '../ProgressBar';
import countriesData from '../../countries.json';
import CommonCurrency from '../../CommonCurrency.json';
import BankNames from '../../BankNames.json';

import { List, ListItem, ListItemText } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';

const EditPartnerView = () => {



    const { showSnackbar } = useSnackbar();
    const { partner, EditPartners, deletePartner, checkEmailExistance, checkPhoneExistance, RegenerateActivationLink } = usePartnerContext();
    const [editableData, setEditableData] = useState({ ...partner });
    const { showProgress } = useProgressBar();
    const navigate = useNavigate();
    // Handler to update the local state when inputs change
    useEffect(() => {
        if (editableData) {
            const editDat = editableData;
            setSelectedCountry(editDat.country || "");
            setSelectedBank(editDat.bankName || "");
            setSelectedCurrency(editDat.currency || "");
            offlineServiceAvailableRef.current.checked = editableData.offlineServiceAvailable;

        }

    }, [editableData]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditableData((prev) => ({ ...prev, [name]: value }));
    };

    const handleActivatePartner = (event) => {
        const isActive = event.target.checked;
        partner.isActive = isActive;
        editableData.isActive = isActive;
        setOpen(true); // Open the confirmation dialog
    };

    const handleClose = () => {
        partner.isActive = partner.isActive ? false : true
        setOpen(false); // Close the confirmation dialog
    };

    const handleConfirm = () => {

        setOpen(false); // Close the confirmation dialog
        //   showSnackbar('Partner Updated successfully!');
    };


    const styles = { inputDisabled: { border: 'none', background: 'none' } };

    const [open, setOpen] = useState(false);
    const [regeneratingLink, setRegeneratingLink] = useState(false);
    const handleCopy = () => {
        showSnackbar("copied to clipboard", "success");
        navigator.clipboard.writeText(partner.activationLink);
    };

    const handleRegenerateLink = async () => {
        setRegeneratingLink(true);
        try {
            const updated = await RegenerateActivationLink(partner.id);
            setEditableData((prev) => ({
                ...prev,
                activationLink: updated.activationLink,
                isVerified: updated.isVerified,
            }));
            showSnackbar('Activation link regenerated and emailed to the partner.', 'success');
        } catch (error) {
            showSnackbar('Failed to regenerate activation link.', 'error');
            console.error('Failed to regenerate activation link:', error);
        } finally {
            setRegeneratingLink(false);
        }
    };

    const partnerNameRef = useRef('');
    const conatactnumberRef = useRef('');
    const emailRef = useRef('');
    const contactpersonRef = useRef('');
    const statusRef = useRef('');
    const partnerClassRef = useRef();
    const vatNumberRef = useRef();
    const bankNameRef = useRef();
    const accountNumberRef = useRef();
    const ibanNumberRef = useRef();
    const accountHolderFullNameRef = useRef();
    const documentNameRef = useRef();
    const currencyRef = useRef();
    const companyRegistrationRef = useRef();
    const companyNameEnglish = useRef();
    const companyNameArabicRef = useRef();
    const companyShortNameRef = useRef();
    const websiteRef = useRef();
    const crNumberRef = useRef();
    const attachmentRef = useRef();
    const ibanRef = useRef();
    const streetRef = useRef('');
    const buildingNoRef = useRef('');
    const neighborhoodRef = useRef('');
    const cityRef = useRef('');
    const stateRef = useRef('');
    const zipcodeRef = useRef('');
    const countryRef = useRef('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [emailExists, setEmailExists] = useState(false);
    const [phoneExists, setPhoneExists] = useState(null);
    const [emailFormat, setEmailFormat] = useState();
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [selectedBank, setSelectedBank] = useState('');
    const offlineServiceAvailableRef = useRef(false);
    const checkEmail = async () => {
        if (emailRef.current.value != "") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(emailRef.current.value)) {
                setEmailFormat(false)
            } else {
                setEmailFormat(true)
            }

            if (partner.email !== emailRef.current.value) {
                const resp = await checkEmailExistance(emailRef.current.value);
                setEmailExists(resp);
            }
        }
    };
    const [isValid, setIsValid] = useState(null);
    const checkPhoneNumber = async () => {
        const number = conatactnumberRef.current.value.trim();
        const phoneregExp = /^\u002B9665\d{8}$/;
        if (number !== "") {
            if (phoneregExp.test(number)) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
            if (partner.contactNumber !== conatactnumberRef.current.value) {
                const resp = await checkPhoneExistance(conatactnumberRef.current.value);
                setPhoneExists(resp);
            }
        }
    };
    const formRefs = useRef([]);
    const handleClick = () => {
        formRefs.current.forEach(form => {
            const formElements = form.elements;
            for (let element of formElements) {

                if ((element.tagName === 'INPUT' && element.type !== 'button') || element.tagName === 'SELECT') {

                    if (element.value == '') {
                        element.style.borderColor = 'red';
                    } else {
                        element.style.borderColor = '';
                    }

                }

            }
        });
    };
    const checkEmptyField = (e) => {
        if (e.target.value === "") {
            e.target.style.borderColor = '';
        } else {
            e.target.style.borderColor = '';
        }
    };
    let isValied = false;
    const handleEditPartner = async () => {

        const partnerName = partnerNameRef.current.value;
        const contactNumber = conatactnumberRef.current.value;
        const email = emailRef.current.value;
        const contactPerson = contactpersonRef.current.value;
        const status = partner.isVerified ? statusRef.current.checked : partner.isVerified;
        if ((partner.email !== emailRef.current.value.trim())) {
            const resp = await checkEmailExistance(emailRef.current.value);
            if (resp == true) {
                isValied = true;
            }
        }
        if (partnerNameRef.current.value.trim() === '' || streetRef.current.value.trim() === '' ||
            buildingNoRef.current.value.trim() === '' || neighborhoodRef.current.value.trim() === '' ||
            cityRef.current.value.trim() === '' || stateRef.current.value.trim() === '' ||
            zipcodeRef.current.value.trim() === '' || countryRef.current.value.trim() === '' ||
            conatactnumberRef.current.value.trim() === '' || emailRef.current.value.trim() === '' ||
            contactpersonRef.current.value.trim() === '' || vatNumberRef.current.value.trim() === '' ||
            bankNameRef.current.value.trim() === '' || accountNumberRef.current.value.trim() === '' ||
            accountHolderFullNameRef.current.value.trim() === '' || partnerClassRef.current.value.trim() === '' ||
            currencyRef.current.value.trim() === '' ||
            companyShortNameRef.current.value.trim() === '' || websiteRef.current.value.trim() === '' || attachmentRef.current.value.trim() === '' || ibanRef.current.value.trim() === '') {
            showSnackbar('Partner name and location cannot be empty.');
            handleClick();
            return;
        } else if (isValied == true) {
            showSnackbar('email already exist', 'error');
            handleClick();
        }
        else if (phoneExists === true) {

            showSnackbar('Phone number already exist', 'error');
            handleClick();
        }
        else {
            try {

                const partnerdata = {
                    id: partner.id,
                    partnerID: partner.partnerID,
                    partnerName: partnerName,
                    contactNumber: contactNumber,
                    email: email,
                    contactPerson: contactPerson,
                    isVerified: partner.isVerified,
                    isActive: status,
                    streetName: streetRef.current.value.trim(),
                    buildingNumber: buildingNoRef.current.value.trim(),
                    neighborhood: neighborhoodRef.current.value.trim(),
                    city: cityRef.current.value.trim(),
                    state: stateRef.current.value.trim(),
                    zipCode: zipcodeRef.current.value.trim(),
                    country: countryRef.current.value.trim(),
                    offlineServiceAvailable: offlineServiceAvailableRef.current.checked,
                };
                // Call AddModel with the necessary data
                showProgress(true);
                editableData.offlineServiceAvailable = offlineServiceAvailableRef.current.checked;
                const p = await EditPartners(editableData, files, selectedFile);

                showProgress(false); setTimeout(() => {
                    navigate(`/editpartner/${p.id}/false`)
                }, 2000);

                showSnackbar('Partner Updated Successfully!'); // Notify success
            } catch (error) {
                showSnackbar('Error Updating Partner. Please try again.');
                console.error('Error Updating Partner:', error);
            }
        }
    };



    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleDeleteClick = () => {
        setConfirmOpen(true); // Open the confirmation dialog
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false); // Close the confirmation dialog
    };
    const handleConfirmDelete = async () => {
        setConfirmOpen(false); // Close the confirmation dialog
        if (editableData && editableData.length > 0) {
            try {

                await deletePartner(editableData.id); // Call delete action
                showSnackbar("Partner deleted successfully", "success");
                navigate('/addpartner'); // Redirect after deletion
            } catch (error) {
                showSnackbar("Failed to delete Partner", "error");
            }
        }
    };


    const [files, setFiles] = React.useState([]);

    const handlePartnerFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };
    const handleFileChange = (event) => {
        debugger;
        setSelectedFile(event.target.files[0]); // Get the first selected file
    };



    const [confirmStatusOpen, setConfirmStatusOpen] = useState(false);
    const [previousValue, setPreviousValue] = useState(false);
    const handleActive = () => {
        if (offlineServiceAvailableRef.current) {
            const current = offlineServiceAvailableRef.current.checked;
            // Save previous value before showing dialog
            setPreviousValue(!current); // Store old state
            setConfirmStatusOpen(true); // Open dialog
        }
    };
    const handleConfirmStatusChange = () => {
        const isChecked = offlineServiceAvailableRef.current?.checked || false;
        // Perform your update logic here (API call, state update, etc.)
        console.log('Status changed to:', isChecked ? 'Enabled' : 'Disabled');

        setConfirmStatusOpen(false);
    };
    const handleStatusDialogClose = () => {
        if (offlineServiceAvailableRef.current) {
            offlineServiceAvailableRef.current.checked = previousValue;
        }
        setConfirmStatusOpen(false); // Close the dialog
    };



    return (
        <div>
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Partner</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item"><a href='/partner'>Partner</a></li>
                            <li className="breadcrumb-item active"><a href=''>Partner Details</a></li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="row">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <nav className="navbar navbar-expand-lg navbar-light">
                                        <div className="container-fluid">

                                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                    <h4 className="mb-3">Partner Details</h4>
                                                </ul>

                                                <Button className="right-button me-2"
                                                    variant="contained"

                                                    style={{ backgroundColor: '#02176D', color: 'white' }}
                                                    onClick={handleEditPartner} >
                                                    Save
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    style={{ backgroundColor: '#02176D', color: 'white' }}
                                                    onClick={handleDeleteClick}
                                                    className="right-button"
                                                >
                                                    Delete Partner
                                                </Button>
                                            </div>
                                        </div>
                                    </nav>


                                    <ConfirmDialog
                                        open={open}
                                        onClose={handleClose}
                                        onConfirm={handleConfirm}
                                        title="Confirm Deactivate/Activate"
                                        content="Are you sure you want to Deactivate/Activate this Partner?"
                                    />



                                    <div className="container my-4">

                                        <form ref={el => formRefs.current[0] = el}>
                                        <div className="row">
                                            

                                            {/* Partner Details */}
                                            <div className="col-md-6">
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <strong>Partner ID:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-75"
                                                            name="partnerID"
                                                            value={editableData.partnerID}
                                                            onChange={handleChange}
                                                            onBlur={(e)=>{ checkEmptyField(e); }
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <strong>Partner Name:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-75"
                                                            name="partnerName"
                                                            value={editableData.partnerName}
                                                            onChange={handleChange}
                                                            ref={partnerNameRef}
                                                            onBlur={(e)=>{ checkEmptyField(e); }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <strong>Contact Number:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-75"
                                                            name="contactNumber"
                                                            value={editableData.contactNumber}
                                                            onChange={handleChange}
                                                            ref={conatactnumberRef}
                                                            onBlur={(e)=>{checkPhoneNumber();checkEmptyField(e);}}
                                                            style={{ borderColor:(phoneExists===true||isValid === false) ? 'red':'' }}
                                                        />
                                                        {phoneExists === true && (
                                                            <div className="form-text text-danger">
                                                                {phoneExists === true ? "Phone number already exists" : "Phone number is available"}
                                                            </div>)}
                                                        {isValid !== null && (<div className="form-text text-danger">{isValid === false ? "Invalid phone number. Please check the format." : ""}</div>)}
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4">
                                                        <strong>Email:</strong>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="email"
                                                            className="form-control form-control-sm w-75"
                                                            name="email"
                                                            value={editableData.email}
                                                            onChange={handleChange}
                                                            onBlur={checkEmail}
                                                            ref={emailRef}
                                                            style={{
                                                                borderColor: (emailExists === true || emailFormat === true) ? 'red' : ''
                                                              }}
                                                        />
                                                        {emailExists === true && (
                                                            <div className="form-text text-danger">
                                                                {emailExists === true ? "Email already exists" : "Email is available"}
                                                            </div>)}
                                                            {emailFormat === true && (
                                                                <div className="form-text text-danger">
                                                                    {emailFormat === true ? "Invalied Email format" : ""}
                                                                </div>)

                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Contact Person:</strong>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm w-75"
                                                                name="contactPerson"
                                                                value={editableData.contactPerson}
                                                                ref={contactpersonRef}
                                                                onChange={handleChange}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Partner Class:</strong>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <select className="form-control form-control-sm w-75"
                                                                name="partnerClass"
                                                                ref={partnerClassRef}
                                                                onChange={handleChange}>
                                                                <option select='selected'>{editableData.partnerClass}</option>
                                                                <option value="Premium" select={editableData.partnerClass == "Premium" ? 'selected' : ''}>Premium</option>
                                                                <option value="Standard" select={editableData.partnerClass == "Standard" ? 'selected' : ''}>Standard</option>
                                                                <option value="Basic" select={editableData.partnerClass == "Basic" ? 'selected' : ''}>Basic</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Offline Service Available :</strong>
                                                        </div>
                                                        <div className="col-md-8"  >
                                                            <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="flexSwitchCheckDefault"
                                                                    ref={offlineServiceAvailableRef}
                                                                    onChange={handleActive}
                                                                />
                                                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">

                                                                    {offlineServiceAvailableRef.current?.checked ? 'Active' : 'Not Active'}
                                                                </label>
                                                            </div>
                                                        </div>


                                                        <Dialog open={confirmStatusOpen} onClose={handleStatusDialogClose}>
                                                            <DialogTitle>Confirm Status Change</DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText>
                                                                    Are you sure you want to {offlineServiceAvailableRef.current?.checked ? 'activate' : 'deactivate'} for this branch?
                                                                </DialogContentText>
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button onClick={handleStatusDialogClose} color="secondary">
                                                                    Cancel
                                                                </Button>
                                                                <Button onClick={handleConfirmStatusChange} color="primary" autoFocus>
                                                                    Confirm
                                                                </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </div>



                                                    <div className="row mb-3">
                                                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label"><strong>Partner Icon:</strong></label>
                                                        <div className="col-sm-10">
                                                            <img height="60px" width="60px" alt="" src={partner.icon}></img>

                                                        </div>
                                                    </div>
                                                    <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column' }}>
                                                        <label htmlFor="file-input" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                                            {/* Attach Icon Aligned to the Left */}
                                                            <IconButton color="primary" component="span" style={{ color: '#02176D', marginLeft: '-16px' }}>
                                                                <AttachFileIcon style={{ fontSize: '20px' }} />
                                                            </IconButton>
                                                            {/* Text Next to Icon */}
                                                            <span style={{ fontSize: '13px', fontWeight: 'bold', marginLeft: '10px' }}>Attach Partner Photos</span>
                                                        </label>
                                                        <input
                                                            type="file"
                                                            multiple
                                                            style={{ display: 'none' }}
                                                            id="file-input"
                                                            onChange={handlePartnerFileChange}
                                                        />
                                                        {/* List of Attached Files */}
                                                        <List>
                                                            {files.map((file, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    secondaryAction={
                                                                        <IconButton edge="end" onClick={() => handleRemoveFile(index)}>
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    }
                                                                >
                                                                    {/* Styled Attached Files Name */}
                                                                    <ListItemText
                                                                        primary={<span style={{ fontWeight: 'bold', color: '#333' }}>{file.name}</span>}
                                                                        secondary={`${(file.size / 1024).toFixed(2)} KB`}
                                                                    />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>Activation link:</strong>
                                                        </div>
                                                        <div className="col-md-8">
                                                            {partner.isVerified && (
                                                                <p className="text-muted small mb-2">
                                                                    Partner is verified. Regenerate to issue a new activation link and reset verification.
                                                                </p>
                                                            )}
                                                            {!partner.isVerified && partner.activationLink && (
                                                                <div className="input-group mb-2">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm"
                                                                        style={{ width: '250px' }}
                                                                        value={partner.activationLink}
                                                                        readOnly
                                                                    />
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm"
                                                                        onClick={handleCopy}
                                                                        type="button"
                                                                    >
                                                                        <i className="bi bi-clipboard"></i>
                                                                    </button>
                                                                </div>
                                                            )}
                                                            <button
                                                                className="btn btn-outline-secondary btn-sm"
                                                                onClick={handleRegenerateLink}
                                                                type="button"
                                                                disabled={regeneratingLink}
                                                            >
                                                                {regeneratingLink ? 'Regenerating...' : 'Regenerate link'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {partner.isVerified && <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <strong>enable/disable</strong>
                                                        </div>
                                                        <div className="col-md-8 form-check form-switch">
                                                            <input className="form-check-input" type="checkbox" checked={editableData.isActive} id="flexSwitchCheckDefault" defaultValue={editableData.isActive} ref={statusRef} onChange={handleActivatePartner}></input>
                                                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Activate/Deactivate Partner</label>
                                                        </div>
                                                    </div>}
                                                </div>
                                                {/* Order and Customer Tabs */}
                                                <div className="col-md-6">
                                                    <ul className="nav nav-tabs" id="partnerDetailsTabs" role="tablist">
                                                        <li className="nav-item" role="presentation">
                                                            <a
                                                                className="nav-link active"
                                                                id="order-tab"
                                                                data-bs-toggle="tab"
                                                                href="#order"
                                                                role="tab"
                                                                aria-controls="order"
                                                                aria-selected="true"
                                                            >
                                                                Order
                                                            </a>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <a
                                                                className="nav-link"
                                                                id="customer-tab"
                                                                data-bs-toggle="tab"
                                                                href="#customer"
                                                                role="tab"
                                                                aria-controls="customer"
                                                                aria-selected="false"
                                                            >
                                                                Customer
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <div className="tab-content mt-3" id="partnerDetailsTabsContent">
                                                        {/* Order Tab */}
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="order"
                                                            role="tabpanel"
                                                            aria-labelledby="order-tab"
                                                        >
                                                            <p>Order-related details go here.</p>
                                                        </div>
                                                        {/* Customer Tab */}
                                                        <div
                                                            className="tab-pane fade"
                                                            id="customer"
                                                            role="tabpanel"
                                                            aria-labelledby="customer-tab"
                                                        >
                                                            <p>Customer-related details go here.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Bank and Company Tabs */}
                                            <ul className="nav nav-tabs mt-4" id="bottomTabs" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-link active"
                                                        id="location-info-tab"
                                                        data-bs-toggle="tab"
                                                        href="#location-info"
                                                        role="tab"
                                                        aria-controls="location-info"
                                                        aria-selected="false"
                                                    >
                                                        Location Information
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-link"
                                                        id="company-info-tab"
                                                        data-bs-toggle="tab"
                                                        href="#company-info"
                                                        role="tab"
                                                        aria-controls="company-info"
                                                        aria-selected="true"
                                                    >
                                                        Company Information
                                                    </a>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <a
                                                        className="nav-link"
                                                        id="bank-info-tab"
                                                        data-bs-toggle="tab"
                                                        href="#bank-info"
                                                        role="tab"
                                                        aria-controls="bank-info"
                                                        aria-selected="false"
                                                    >
                                                        Bank Information
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content mt-3" id="bottomTabsContent">
                                                {/* Location Information Tab */}
                                                <div
                                                    className="tab-pane fade show active"
                                                    id="location-info"
                                                    role="tabpanel"
                                                    aria-labelledby="location-info-tab"
                                                >
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Street:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="streetName"
                                                                value={editableData.streetName}
                                                                onChange={handleChange}
                                                                ref={streetRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Building Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="buildingNumber"
                                                                value={editableData.buildingNumber}
                                                                onChange={handleChange}
                                                                ref={buildingNoRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Neighborhood:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="neighborhood"
                                                                value={editableData.neighborhood}
                                                                onChange={handleChange}
                                                                ref={neighborhoodRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>City:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="city"
                                                                value={editableData.city}
                                                                onChange={handleChange}
                                                                ref={cityRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>State:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="state"
                                                                value={editableData.state}
                                                                onChange={handleChange}
                                                                ref={stateRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Zipcode:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="zipCode"
                                                                value={editableData.zipCode}
                                                                onChange={handleChange}
                                                                ref={zipcodeRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Country:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            {/*<input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="country"
                                                            value={editableData.country}
                                                            onChange={handleChange}
                                                            ref={countryRef}
                                                            onBlur={(e)=>{
                                                             checkEmptyField(e);
                                                            }}
                                                        />*/}
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="country"
                                                                value={selectedCountry}
                                                                onChange={handleChange}
                                                                ref={countryRef}
                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            >
                                                                <option value=""></option>
                                                                {countriesData.map((option, index) => (<option key={index} value={option.Name}>{option.Name}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                </div>

                                                {/* Company Information Tab */}
                                                <div
                                                    className="tab-pane fade"
                                                    id="company-info"
                                                    role="tabpanel"
                                                    aria-labelledby="company-info-tab"
                                                >
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>CR Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="crNumber"
                                                                value={editableData.crNumber}
                                                                onChange={handleChange}
                                                                ref={crNumberRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Company Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="companyName"
                                                                value={editableData.companyName}
                                                                onChange={handleChange}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Company Name (AR):</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="companyNameAR"
                                                                value={editableData.companyNameAR}
                                                                onChange={handleChange}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Short Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="companyShortName"
                                                                value={editableData.companyShortName}
                                                                onChange={handleChange}
                                                                ref={companyShortNameRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Website:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="website"
                                                                value={editableData.website}
                                                                onChange={handleChange}
                                                                ref={websiteRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>VAT Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="vatNumber"
                                                                value={editableData.vatNumber}
                                                                onChange={handleChange}
                                                                ref={vatNumberRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bank Information Tab */}
                                                <div
                                                    className="tab-pane fade"
                                                    id="bank-info"
                                                    role="tabpanel"
                                                    aria-labelledby="bank-info-tab"
                                                >
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Bank Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            {/*<input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="bankName"
                                                            value={editableData.bankName}
                                                            onChange={handleChange}
                                                            ref={bankNameRef}
                                                            onBlur={(e)=>{ checkEmptyField(e); }}
                                                        />*/}
                                                            <select className="form-control form-control-sm"
                                                                name="bankName"
                                                                value={selectedBank}
                                                                onChange={handleChange}
                                                                ref={bankNameRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            >
                                                                <option value=""></option>
                                                                {BankNames.map((option, index) => (<option key={index} value={option.en_name}>{option.en_name}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Account Number:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="accountNumber"
                                                                value={editableData.accountNumber}
                                                                onChange={handleChange}
                                                                ref={accountNumberRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}

                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Document Name</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="documentName"
                                                                ref={attachmentRef}
                                                                value={editableData.attachmentName}

                                                                onBlur={(e) => {
                                                                    checkEmptyField(e);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Attachment</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input className="form-control" type="file" id="formFile" onChange={handleFileChange} onBlur={(e) => {
                                                                checkEmptyField(e);
                                                            }} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>IBAN:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="iban"
                                                                value={editableData.iban}
                                                                onChange={handleChange}
                                                                ref={ibanRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Account Holder Name:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                name="accountHolderFullName"
                                                                value={editableData.accountHolderFullName}
                                                                onChange={handleChange}
                                                                ref={accountHolderFullNameRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}

                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-2">
                                                            <strong>Currency:</strong>
                                                        </div>
                                                        <div className="col-md-4">
                                                            {/*<input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            name="currency"
                                                            value={editableData.currency}
                                                            onChange={handleChange}
                                                            ref={currencyRef}
                                                            onBlur={(e)=>{ checkEmptyField(e); }}
                                                        />*/}
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="currency"
                                                                value={selectedCurrency}
                                                                onChange={handleChange}
                                                                ref={currencyRef}
                                                                onBlur={(e) => { checkEmptyField(e); }}
                                                            >
                                                                <option value=""></option>
                                                                {CommonCurrency.map((option, index) => (<option key={index} value={option.currency}>{option.currency}</option>))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{ position: 'relative' }}>
                                                        <div className="col-12 text-center">


                                                            {/* Confirmation Dialog */}
                                                            <Dialog
                                                                open={confirmOpen}
                                                                onClose={handleConfirmClose}
                                                            >
                                                                <DialogTitle>Confirm Deletion</DialogTitle>
                                                                <DialogContent>
                                                                    <DialogContentText>
                                                                        Are you sure you want to delete this Partner?
                                                                    </DialogContentText>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button onClick={handleConfirmClose} color="secondary">
                                                                        Cancel
                                                                    </Button>
                                                                    <Button onClick={handleConfirmDelete} color="primary" autoFocus>
                                                                        Confirm
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </main>


        </div>
    )
};

export default EditPartnerView;